import React from "react";
import { Grid } from "@material-ui/core";
import ApiField from "./ApiField/ApiField";
import { Values } from "@src/Tools/Values";
import { inject, observer } from "mobx-react";
import { IAuthStore } from "@src/Stores/Auth/types";
import { STGrid, STProfileFieldsWrapper, STLink, STInputLabel, STImg } from "./styles";
import { observable } from "mobx";
import { IManagementStore } from "@src/Stores/Management/types";
import STPageHeader from "@src/Components/Ui/STPageHeader";
import AppPreloader from "@src/Components/Common/AppPreloader/AppPreloader";
import { IValuesStore } from "@src/Stores/Values/types";

const xs = 12;
const sm = 12;
const md = 12;

interface IProps {
  auth?: IAuthStore;
  management?: IManagementStore;
  values?: IValuesStore;
}

interface IValues {
  url: string;
  swaggerUrl: string;
  apiKey: string;
}

@inject("auth", "management", "values")
@observer
export default class Api extends React.Component<IProps> {
  @observable isLoading: boolean = true;
  public values: IValues;
   
  async componentDidMount() {
    let umUrl = await this.props.values.getUserManagementUrl();
    let swaggerUrl = await this.props.values.getSwaggerUrl(true);

    this.values = {
      url: `${umUrl}api/{controller}/{action}`,
      swaggerUrl: swaggerUrl,
      apiKey: this.props.auth.user.person.apiKey
    };
    document.title = Values.getLocalizationValue("api");
    this.isLoading = false;
  }

  render() {
    if (this.isLoading) {
      return <AppPreloader />;
    }
    return (
      <Grid container justify="center">
        <Grid item xs={12}>
          <STPageHeader>
            {Values.getLocalizationValue("api")}
          </STPageHeader>
        </Grid>
        <Grid item>
          <STProfileFieldsWrapper>
            <STGrid container justify="center" alignItems="center" spacing={16}>
              {this.values.apiKey && (<Grid item xs={xs} sm={sm} md={md}>
                <ApiField
                  label={Values.getLocalizationValue("apiKey")}
                  value={this.values.apiKey}
                />
              </Grid>)}
              <Grid item xs={xs} sm={sm} md={md}>
                <ApiField
                  label={Values.getLocalizationValue("uRL")}
                  value={this.values.url}
                />
              </Grid>
              <Grid item xs={xs} sm={sm} md={md}>
                <STInputLabel>{Values.getLocalizationValue("swagger")}</STInputLabel>
                <STLink href={this.values.swaggerUrl} target="_blank">
                  <STImg
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAYFBMVEUAAABUfwBUfwBUfwBUfwBUfwBUfwBUfwBUfwBUfwBUfwBUfwBUfwBUfwBUfwB0lzB/n0BfhxBpjyC0x4////+qv4CJp1D09++ft3C/z5/K16/U379UfwDf58/q79+Ur2D2RCk9AAAAHXRSTlMAEEAwn9//z3Agv4/vYID/////////////////UMeji1kAAAD8SURBVHgBlZMFAoQwDATRxbXB7f+vPKnlXAZn6k2cf3A9z/PfOC8IIYni5FmmABM8FMhwT17c9hnhiZL1CwvEL1tmPD0qSKq6gaStW/kMXanVmAVRDUlH1OvuuTINo6k90Sxf8qsOtF6g4ff1osP3OnMcV7d4pzdIUtu1oA4V0DZoKmxmlEYvtDUjjS3tmKmqB+pYy8pD1VPf7jPE0I40HHcaBwnue6fGzgyS5tXIU96PV7rkDWHNLV0DK4FkoKmFpN5oUnvi8KoeA2/JXsmXQuokx0siR1G8tLkN6eB9sLwJp/yymcyaP/TrP+RPmbMMixcJVgTR1aUZ93oGXsgXQAaG6EwAAAAASUVORK5CYII="
                    alt={Values.getLocalizationValue("swagger")}
                  />{Values.getLocalizationValue("swaggerUI")}</STLink>
              </Grid>
            </STGrid>
          </STProfileFieldsWrapper>
        </Grid>
      </Grid>
    );
  }
}
